import React, { useState, useEffect } from "react";
import { Flex, Heading, Text, Spinner } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { getStripeInvoicesAction } from "../../../../../actions/tenantActions";
import { primary, newBorder } from "../../../../../utils/colors";
import Table from "../../../../../components/shared/Table";
import { useTranslation } from "react-i18next";
import { columns } from "./TenantInvoicesColumns"; // Adjust the path according to your file structure
import useIsMobile from "../../../../../hooks/useIsMobile";
import TableContainerWindowed from "../../../../../components/shared/Table/TableContainerWindowed";
import { useParams } from "react-router-dom";

const Invoices = () => {
  // GENERAL
  const { slug } = useParams();
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  // STATE
  const [searchTitle, setSearchTitle] = useState("");

  // REDUX
  const dispatch = useDispatch();

  const authLogin = useSelector((state) => state.authLogin);
  const { userInfo } = authLogin;

  const tenantGetStripeInvoices = useSelector(
    (state) => state.tenantGetStripeInvoices
  );

  const { loading, error, invoices } = tenantGetStripeInvoices;

  // USEEFFECT
  // useEffect(() => {
  //   if (!invoices || invoices.length === 0) {
  //     dispatch(getStripeInvoices());
  //   }
  // }, [dispatch, invoices]);

  useEffect(() => {
    if (slug) {
      dispatch(getStripeInvoicesAction(slug)); // Ensure tenantID is passed
    }
  }, [dispatch, slug]);

  // CUSTOM
  const paidInvoices =
    (invoices && invoices?.filter((inv) => inv.status === "paid")) || [];

  // LOGS

  console.log("invoices", invoices);
  // console.log("currentInvoices", currentInvoices);

  // RENDER

  return (
    <Flex direction="column" w="100%" m="3rem 0 0">
      <Heading
        fontSize="1rem"
        color="textPrimary"
        fontWeight="600"
        m={0}
        p="0 0 0.75rem"
      >
        {t("module.invoices")}
      </Heading>

      <Flex
        w="100%"
        border={`1px solid ${newBorder}`}
        borderRadius="1rem"
        direction="column"
        overflow="hidden"
      >
        <TableContainerWindowed
          columns={columns(t)}
          data={paidInvoices}
          loading={loading}
          error={error}
          // onRowClick={(userId) => {
          //   setIsSidePanelLongOpen(true);
          //   setUserId(userId);
          //   document.body.classList.add("no-scroll");
          // }}
          // noItemsButtonHandler={openSidePanelModal}
          noItemsTitle={t("noItems.noInvoices")}
          noItemsDescription={t("noItems.noInvoicesText")}
          noItemsButtonLabel={t("noItems.noInvoicesButton")}
          // noItemsButtonHandler={openCreatePatientSidePanelModal}
          // noItemsButtonDisabled={isDoctor}
          // sortField={sortField}
          // sortOrder={sortOrder}
        />
        {/* <Table.Pagination
          loading={loading}
          // page={page}
          // pages={pages}
          // pageSize={pageSize}
          // pageSizes={pageSizes}
          // navigate={navigate}
          // setPage={setPage}
          // setPageSize={setPageSize}
          // totalCount={patients.length}
        /> */}
      </Flex>
    </Flex>
  );
};

export default Invoices;
